import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";

import collection from "./img/carres/collection.jpeg";
import angoisse from "./img/carres/angoisse.jpeg";
import cigarette from "./img/carres/cigarette.jpeg";
import diagnostic from "./img/carres/diagnostic.jpeg";
import plafonnement from "./img/carres/plafonnement.jpeg";
import psychiatrie from "./img/carres/psychiatrie.jpeg";
import psychopathe from "./img/carres/psychopathe.jpeg";
import suicide from "./img/carres/suicide.jpeg";
import temporalite from "./img/carres/temporalite.jpeg";
import traitement from "./img/carres/traitement.jpeg";

export interface Outil {
  id: number;
  nom: string;
  image: string;       // image de couverture
  description: string;
  panier: boolean;
  prix: number;
}

export interface PanierElement {
  idOutil: number;
  nombre: number;
}

export const outilListe: Outil[] = [
  { id: 0, nom: "Collection", image: collection, description: "8 livrets format A5", panier: false, prix: 4500 },
  { id: 1, nom: "Angoisse", image: angoisse, description: "Livret format A5", panier: false, prix: 500 },
  { id: 2, nom: "Temporalité", image: temporalite, description: "Livret format A5", panier: false, prix: 500 }, // tu n'as pas donné d'images pour lui
  { id: 3, nom: "Cigarette", image: cigarette, description: "Livret format A5", panier: false, prix: 500 },
  { id: 4, nom: "Diagnostic", image: diagnostic, description: "Livret format A5", panier: false, prix: 500 },
  { id: 5, nom: "Plafonnement", image: plafonnement, description: "Livret format A5", panier: false, prix: 500 },
  { id: 6, nom: "Psychiatrie", image: psychiatrie, description: "Livret format A5", panier: false, prix: 500 },
  { id: 7, nom: "Psychopathe", image: psychopathe, description: "Livret format A5", panier: false, prix: 500 },
  { id: 8, nom: "Traitement", image: traitement, description: "Livret format A5", panier: false, prix: 500 },
  { id: 8, nom: "Suicide", image: suicide, description: "Livret format A5", panier: false, prix: 500 },
];

type PanierContextType = {
  panier: PanierElement[];
  setPanier: React.Dispatch<React.SetStateAction<PanierElement[]>>;
  livraison: number;
  togglePanier: (panierElement: PanierElement) => void;
};

const PanierContext = createContext<PanierContextType | undefined>(undefined);

export const PanierProvider = ({ children }: { children: ReactNode }) => {
  const [panier, setPanier] = useState<PanierElement[]>(() => {
    try {
      const panierStocké = localStorage.getItem("panier");
      return panierStocké ? (JSON.parse(panierStocké) as PanierElement[]) : [];
    } catch (error) {
      console.error("Erreur lors du chargement du panier :", error);
      return [];
    }
  });

  // 🔄 Sauvegarde dans localStorage quand le panier change
  useEffect(() => {
    localStorage.setItem("panier", JSON.stringify(panier));
  }, [panier]);

  // Ajout/suppression d’un outil
  const togglePanier = (panierElement: PanierElement) => {
    setPanier((prev) => {
      const existe = prev.find((o) => o.idOutil === panierElement.idOutil);
      if (existe) {
        return prev.filter((o) => o.idOutil !== panierElement.idOutil);
      } else {
        return [...prev, panierElement];
      }
    });
  };

  return (
    <PanierContext.Provider value={{ panier, setPanier, livraison:6, togglePanier }}>
      {children}
    </PanierContext.Provider>
  );
};

// Hook personnalisé pour accéder au panier
export const usePanier = () => {
  const context = useContext(PanierContext);
  if (!context) {
    throw new Error("usePanier doit être utilisé dans un PanierProvider");
  }
  return context;
};


